var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { staticClass: "Alert" }, [
        _c("div", { staticClass: "mask" }),
        _vm._v(" "),
        _c("div", { staticClass: "popContent" }, [
          _c("div", { staticClass: "panels" }, [
            _vm.title
              ? _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c(
                "div",
                {
                  staticClass: "description",
                  style: { textAlign: _vm.align || "left" }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.text) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "buttonArea" }, [
                _c(
                  "div",
                  { staticClass: "btns red flex1", on: { click: _vm.submit } },
                  [_vm._v(_vm._s(_vm.buttonText))]
                )
              ])
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ec1bd06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ec1bd06","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ui/alert/index.vue
// module id = null
// module chunks = 